import React, { useState } from "react";
import "./DescribeGoal.css";
import { useNavigate } from "react-router-dom";
import ProgressBar from "../../Components/ProgressBar";
import Images from "../../Assets/Images";

function DescribeGoal() {
  const [selectedGoal, setSelectedGoal] = useState(null);
  const navigate = useNavigate();
  const cardData = [
    {
      title: "Card title 1",
      text: "Some quick example text to build on the card title and make up the bulk of the card's content.",
    },
    {
      title: "Card title 2",
      text: "Some quick example text to build on the card title and make up the bulk of the card's content.",
    },
    {
      title: "Card title 3",
      text: "Some quick example text to build on the card title and make up the bulk of the card's content.",
    },
  ];

  const handleSubmit = () => {
    navigate("/Plan");
  };

  return (
    <div className="container-goal">
      <img src={Images.logo_bg} />
      <ProgressBar completed={60}/>
      <h1 className="heading">
        Describe Your Goal <br /> for using{" "}
        <span className="highlight">QFLyers</span>
      </h1>

      <p>This helps us personalize your experience</p>
      <div>
        <div>
          {/* {cardData.map((card, index) => (
            <Card key={index} title={card.title} text={card.text} />
          ))} */}
        </div>
      </div>
      <div>
        <button className="btn-continue mt-3" onClick={handleSubmit}>
          Continue
        </button>
      </div>
    </div>
  );
}

export default DescribeGoal;
